<template>
  <section class="card" id="skills-section">
    <h4
      class="card-header collapse-bar"
      data-toggle="collapse"
      href="#skill-details"
      role="button"
      aria-expanded="false"
      aria-controls="skill-details"
      @click="animateIcon"
    >
      <!-- click action to collapse-->
      <transition name="fade" mode="out-in">
        <span class="collapse-icon" v-if="isCollapsed" key="closed">
          <font-awesome-icon :icon="['fas', 'angle-double-up']" />
        </span>
        <span class="collapse-icon" v-else key="open">
          <font-awesome-icon :icon="['fas', 'angle-double-down']" />
        </span>
      </transition>
      Skills
    </h4>
    <div id="skill-details" class="card-body collapse">
      <!-- collapseable section-->
      <div v-for="(category, index) in skillCategories" :key="index + '-cat'">
        <h6>{{ category }}</h6>
        <ul class="card-text">
          <li
            v-for="(skill, innerIndex) in skills(category)"
            :key="innerIndex + '-skill'"
          >
            {{ skill.skillName }} - {{ skill.level }}
          </li>
        </ul>
      </div>
      <a href="#skills-details" class="btn btn-link float-right">To Top</a>
    </div>
  </section>
</template>

<script>
import _ from 'lodash'
import { getSkills } from './../../db'
import { animateIconMixin } from './animateIconMixin'

export default {
  name: 'Skills',
  data() {
    return {
      skillsData: [],
      skillsInfo: [],
    }
  },
  mixins: [animateIconMixin],
  computed: {
    skillCategories() {
      const cats = new Set()
      this.skillsData.forEach((skill) => cats.add(skill.category))
      let array = Array.from(cats)
      return _.sortBy(array)
    },
  },
  methods: {
    skills(category) {
      let array = Array.from(
        this.skillsData.filter((skill) => skill.category == category)
      )
      return _.sortBy(array, 'skillName')
    },
  },
  mounted() {
    getSkills().then((vals) => {
      this.skillsData = vals
    })
  },
}
</script>
